import { isValid, parse, subDays } from 'date-fns'

interface ParseDate {
  (date?: '' | undefined | null): undefined
  (date: string): Date
  (date: null): undefined
  (date?: string | undefined | null): Date | undefined
}

export const FILTER_DATE_FORMAT = 'MM-dd-yyyy'

export const getDateBeforeToday = () => subDays(new Date(), 1)

export const parseDateFromFilter = ((date?: string | null) => {
  return isDateValid(date) ? parse(date, FILTER_DATE_FORMAT, new Date()) : undefined
}) as ParseDate

export const isDateValid = (date?: unknown): date is Date | number | string => {
  // We need to replace the '-' with '/' in the date string or it's invalid in Safari
  const normalizedDate = typeof date === 'string' ? new Date(date.replace(/-/g, '/')) : date
  return isValid(normalizedDate)
}
